/**
 * giveaway-row.js — behaviour for the giveaway entries row (snippets/giveaway-row.liquid)
 * on the cart page, cart drawer and product pages.
 *
 *  1. Exact-minute cut-off: Liquid decides the window at render time; this hides (or
 *     reveals) the row if a page is left open across the NZ midnight that opens or
 *     closes the window. NZ wall-clock via Intl, never the device time zone. Rides the
 *     shared DispatchCountdown minute ticker when present.
 *  2. Product pages: re-computes "Earns N entries" from detail.variant.price on the
 *     heroes' `on:variant:change` event.
 *
 * Loaded by the snippet itself (possibly several times per page); guarded to bind once.
 */
(function () {
  if (window.__mfGiveawayRowBound) return;
  window.__mfGiveawayRowBound = true;

  function nzToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Pacific/Auckland', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      var map = {};
      for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      if (!map.year || !map.month || !map.day) return null;
      return map.year + '-' + map.month + '-' + map.day;
    } catch (e) {
      return null;
    }
  }

  function applyWindow() {
    var rows = document.querySelectorAll('[data-giveaway-row]');
    if (!rows.length) return;
    var today = nzToday();
    if (!today) return; // no reliable NZ clock: leave Liquid's decision alone
    rows.forEach(function (row) {
      var start = row.getAttribute('data-giveaway-start') || '';
      var end = row.getAttribute('data-giveaway-end') || '';
      var hide = (end && today > end) || (start && today < start);
      if (row.hidden !== hide) row.hidden = hide;
    });
  }

  function applyVariant(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-giveaway-row][data-giveaway-entry-cents]').forEach(function (row) {
      var entryCents = parseInt(row.getAttribute('data-giveaway-entry-cents'), 10);
      if (!entryCents) return;
      var entries = Math.floor(variant.price / entryCents);
      var has = row.querySelector('[data-giveaway-has-entries]');
      var none = row.querySelector('[data-giveaway-no-entries]');
      var count = row.querySelector('[data-giveaway-count]');
      if (count) {
        var txt = entries + (entries === 1 ? ' entry' : ' entries');
        if (count.textContent !== txt) count.textContent = txt;
      }
      if (has) has.hidden = entries === 0;
      if (none) none.hidden = entries > 0;
    });
  }

  function bind() {
    if (window.DispatchCountdown && window.DispatchCountdown.onTick) {
      window.DispatchCountdown.onTick(applyWindow);
    } else {
      applyWindow();
      setInterval(applyWindow, 60000);
    }
    // Cart surfaces re-render after every cart change; re-check the fresh row.
    new MutationObserver(applyWindow).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('on:variant:change', function (evt) {
      applyVariant(evt.detail && evt.detail.variant);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
